<template>
<div class="informer" :class="[direction ? 'informer--' + direction : '', size ? 'informer--' + size : '', open ? 'open' : '']">
	<button class="informer__btn" type="button" @mouseenter="open = true" @mouseleave="open = false">
		<svg class="informer__btn-icon">
			<use href="#svg-icon-informer"></use>
		</svg>
	</button>
	<teleport v-if="isMob" to="body">
		<transition name="informer-panel">
			<div v-if="open" class="informer__panel">
				<button class="informer__panel-close">
					<svg class="informer__panel-close-icon"><use href="#svg-icon-close"></use></svg>
				</button>
				<slot></slot>
			</div>
		</transition>
	</teleport>
	<transition v-else name="fade">
		<div class="informer__body" v-if="open" :ref="setBody">
			<slot></slot>
		</div>
	</transition>

</div>
</template>

<script>

import breakpointsMixin from '../../mixins/breakpoints-mixin.vue';

export default {

	mixins: [
		breakpointsMixin
	],

	props: {
		size: {
			type: String,
			default: null
		}
	},

	watch: {
		open(state) {
			this.checkDirection();
			document[state ? 'addEventListener': 'removeEventListener']('click', this.handlerClickOutside);
		}
	},

	created() {
		this.checkDirection();
		window.addEventListener('resize', this.resizeHandler);
	},

	unmounted() {
		window.removeEventListener('resize', this.resizeHandler);
		document.removeEventListener('click', this.handlerClickOutside);
	},

	data() {
		return {
			open: false,
			direction: null,
			body: null
		}
	},

	methods: {
		handlerClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.open = false;
			}
		},

		resizeHandler() {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(this.checkDirection, 400);
		},

		checkDirection() {
			if (this.body) {
				this.direction = window.innerWidth < this.body.getBoundingClientRect().left + this.body.clientWidth ? 'right' : this.direction;
			}
		},

		setBody(el) {
			this.body = el;
		}
	}
}

</script>